// @ts-ignore
import EventBus from "../../lib/event_bus/event_bus";

export default new EventBus();
